import React  from 'react';
function GoldZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >الحالة</th>
          <th > النتائج</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>وجوب الزكاة	</td>
          <td>{result.goldZakatDuty === 'yes' ? 'تجب عليك الزكاة' : 'لا تجب عليك الزكاة'}</td>
        </tr>
        <tr >
          <td>وزن الذهب الصافي	 </td>
          <td>{result.totalPureGoldWeight} (غ) </td>
        </tr>
        <tr >
          <td>نصاب زكاة الذهب</td>
          <td>{result.goldWeightThreshold} (غ)</td>
        </tr>
        <tr >
          <td>مقدار الزكاة الواجب إخراجها (من المال)</td>
          <td>{result.moneyZakatAmount} </td>
        </tr>
        <tr >
          <td>مقدار الزكاة الواجب إخراجها (من الذهب)</td>
          <td>{result.goldZakatAmount} (غ)</td>
        </tr>
      </tbody>
    </table>
  );
}
export default GoldZakatTable;
